import { BASE_URL } from '../../constants/baseUrl';
import axiosInstance from '../../utils/axiosInstance';

class ShipmentService {
  fetchShipments = (
    page = 1,
    pageSize = 10,
    status = '',
    fromDate = null,
    toDate = null,
    search = '',
  ) => {
    let url = `${BASE_URL}/v1/shipments?page=${page}&pageSize=${pageSize}`;

    if (status) {
      url += `&status=${status}`;
    }

    if (fromDate) {
      const formattedFromDate =
        fromDate instanceof Date
          ? fromDate.toISOString().split('T')[0]
          : fromDate.format
            ? fromDate.format('YYYY-MM-DD')
            : fromDate;
      url += `&fromDate=${formattedFromDate}`;
    }

    if (toDate) {
      const formattedToDate =
        toDate instanceof Date
          ? toDate.toISOString().split('T')[0]
          : toDate.format
            ? toDate.format('YYYY-MM-DD')
            : toDate;
      url += `&toDate=${formattedToDate}`;
    }

    if (search) {
      if (/^\d+$/.test(search)) {
        if (search.length <= 5) {
          url += `&shipmentId=${search}`;
        } else {
          url += `&phoneNo=${search}`;
        }
      } else {
        url += `&search=${search}`;
      }
    }

    return axiosInstance
      .get(url, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        // Transform the response to match expected format
        // Handle nested response structure (response.data.data) or direct structure (response.data)
        const responseData = response.data?.data;

        if (responseData) {
          // Extract pagination from API response (camelCase: totalRecords, page, pageSize)
          const apiTotalRecords = responseData.totalRecords;
          const apiPage = responseData.page;
          const apiPageSize = responseData.pageSize;

          return {
            ...response,
            data: {
              status: response.data?.status,
              message: response.data?.message,
              data: {
                result: responseData.result,
                total_records: apiTotalRecords,
                page: apiPage,
                page_size: apiPageSize,
              },
              status_code: response.data?.status_code,
            },
          };
        }
        return response;
      });
  };

  deleteShipment = (id) => {
    return axiosInstance.delete(`${BASE_URL}/v1/shipments/${id}`);
  };

  // Get shipment by ID
  getShipmentById = (id) => {
    return axiosInstance.get(`${BASE_URL}/v1/shipments/${id}`);
  };

  // Update shipment status
  updateShipmentStatus = (id, status) => {
    return axiosInstance.put(`${BASE_URL}/v1/shipments/${id}/status`, {
      status,
    });
  };
}

const shipmentServiceInstance = new ShipmentService();
export default shipmentServiceInstance;
